import {
  Checkbox as ChakraCheckbox,
  CheckboxGroup as ChakraCheckboxGroup,
} from '@chakra-ui/react'
import * as React from 'react'

export interface CheckboxProps extends ChakraCheckbox.RootProps {
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  rootRef?: React.Ref<HTMLLabelElement>
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  function Checkbox(props, ref) {
    const {
      children,
      inputProps,
      rootRef,
      size = 'md',
      fontSize = 'md',
      ...rest
    } = props
    const hoverBgSize =
      size === 'md'
        ? 'var(--chakra-sizes-7)'
        : size === 'lg'
          ? 'var(--chakra-sizes-8)'
          : 'var(--chakra-sizes-6)'
    return (
      <ChakraCheckbox.Root
        ref={rootRef}
        size={size}
        p={1}
        gap={3}
        w="fit-content"
        alignItems="start"
        position="relative"
        {...rest}
      >
        <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
        <ChakraCheckbox.Control
          borderRadius="sm"
          borderColor="gray.500"
          borderWidth="2px"
          _checked={{
            borderColor: 'colorPalette.500',
            bg: 'colorPalette.500',
          }}
          _indeterminate={{
            borderColor: 'colorPalette.500',
            bg: 'colorPalette.500',
          }}
          _readOnly={{
            color: 'gray.500',
            opacity: 'disabled',
            _checked: {
              opacity: 1,
              borderColor: 'gray.200',
              bg: 'gray.200',
            },
            _hover: {
              '&::before': {
                display: 'none',
              },
            },
          }}
          _hover={{
            '&::before': {
              content: '""',
              bgColor: 'colorPalette.500/8',
              position: 'absolute',
              width: hoverBgSize,
              height: hoverBgSize,
              borderRadius: 'full',
            },
          }}
        >
          <ChakraCheckbox.Indicator />
        </ChakraCheckbox.Control>
        {children != null && (
          <ChakraCheckbox.Label fontWeight="normal" fontSize={fontSize}>
            {children}
          </ChakraCheckbox.Label>
        )}
      </ChakraCheckbox.Root>
    )
  },
)

export const CheckboxGroup = ChakraCheckboxGroup
